var A = Object.defineProperty;
var S = (s, e, t) => e in s ? A(s, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : s[e] = t;
var V = (s, e, t) => S(s, typeof e != "symbol" ? e + "" : e, t);
import h from "axios";
const j = "http://localhost:3000".replace(/\/+$/, "");
class w {
  constructor(e, t = j, r = h) {
    V(this, "configuration");
    this.basePath = t, this.axios = r, e && (this.configuration = e, this.basePath = e.basePath || this.basePath);
  }
}
class D extends Error {
  constructor(e, t) {
    super(t), this.field = e, this.name = "RequiredError";
  }
}
const I = "https://example.com", p = function(s, e, t) {
  if (t == null)
    throw new D(
      e,
      `Required parameter ${e} was null or undefined when calling ${s}.`
    );
};
function E(s, e, t = "") {
  e != null && (typeof e == "object" ? Array.isArray(e) ? e.forEach((r) => E(s, r, t)) : Object.keys(e).forEach(
    (r) => E(s, e[r], `${t}${t !== "" ? "." : ""}${r}`)
  ) : s.has(t) ? s.append(t, e) : s.set(t, e));
}
const m = function(s, ...e) {
  const t = new URLSearchParams(s.search);
  E(t, e), s.search = t.toString();
}, C = function(s, e, t) {
  const r = typeof s != "string";
  return (r && t && t.isJsonMime ? t.isJsonMime(e.headers["Content-Type"]) : r) ? JSON.stringify(s !== void 0 ? s : {}) : s || "";
}, b = function(s) {
  return s.pathname + s.search + s.hash;
}, O = function(s, e, t, r) {
  return (a = e, o = t) => {
    const n = { ...s.options, url: ((r == null ? void 0 : r.basePath) || o) + s.url };
    return a.request(n);
  };
}, x = {
  PROJECT: "project"
}, Q = {
  PROJECT: "project"
}, B = {
  PENDING: "pending",
  ACCEPTED: "accepted",
  REVOKED: "revoked",
  EXPIRED: "expired"
}, $ = {
  ARCHIVE_ADDON: "ethereum_archive_addon",
  REQUEST_ADDON: "ethereum_request_addon",
  POLYGON_ADDON: "ethereum_polygon_addon",
  OPTIMISM_ADDON: "ethereum_optimism_addon",
  ARBITRUM_ADDON: "ethereum_arbitrum_addon"
}, L = {
  BASE: "ethereum_base",
  TIER_1: "ethereum_tier_1",
  TIER_2: "ethereum_tier_2",
  TIER_3: "ethereum_tier_3"
}, q = {
  ALREADY_EXISTS: "already_exists",
  BAD_REQUEST: "bad_request",
  FORBIDDEN: "forbidden",
  INTERNAL_ERROR: "internal_error",
  INVALID_USER: "invalid_user",
  NOT_FOUND: "not_found",
  UNKNOWN: "unknown"
}, k = {
  AGREE: "agree"
}, H = {
  PENDING: "pending",
  ACCEPTED: "accepted",
  REVOKED: "revoked",
  EXPIRED: "expired"
}, M = {
  PENDING: "pending",
  ACCEPTED: "accepted",
  REVOKED: "revoked",
  EXPIRED: "expired"
}, G = {
  PROJECT: "project"
}, J = {
  PROJECT: "project"
}, K = {
  ETHEREUM: "ethereum",
  IPFS: "ipfs"
}, W = {
  ADMIN: "admin",
  CONTRIBUTOR: "contributor"
}, y = {
  OWNER: "owner",
  ADMIN: "admin",
  CONTRIBUTOR: "contributor"
}, X = {
  CUSTOM: "custom",
  HACKERONE: "hackerone",
  INTERNAL: "internal",
  CONSENSYS: "consensys"
}, F = function(s) {
  return {
    /**
     * Accept an invitation. Returns the updatedAt invitation.
     * @param {string} invitationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    acceptInvitation: async (e, t = {}) => {
      p("acceptInvitation", "invitationId", e);
      const r = "/invitations/{invitationId}/accept".replace(
        "{invitationId}",
        encodeURIComponent(String(e))
      ), a = new URL(r, I);
      let o;
      s && (o = s.baseOptions);
      const n = { method: "POST", ...o, ...t }, c = {};
      m(a, {});
      let i = o && o.headers ? o.headers : {};
      return n.headers = { ...c, ...i, ...t.headers }, {
        url: b(a),
        options: n
      };
    },
    /**
     * Add a collaborator to a project
     * @param {Product} product
     * @param {string} projectId
     * @param {boolean} [removed] Filter on whether the collaborators have been removed from the project.
     * @param {boolean} [uks]
     * @param {CreateProjectCollaborationInput} [createProjectCollaborationInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addProjectCollaborator: async (e, t, r, a, o, n = {}) => {
      p("addProjectCollaborator", "product", e), p("addProjectCollaborator", "projectId", t);
      const c = "/projects/{product}/{projectId}/collaborators".replace("{product}", encodeURIComponent(String(e))).replace("{projectId}", encodeURIComponent(String(t))), l = new URL(c, I);
      let i;
      s && (i = s.baseOptions);
      const d = { method: "POST", ...i, ...n }, u = {}, v = {};
      r !== void 0 && (v.removed = r), a !== void 0 && (v.uks = a), u["Content-Type"] = "application/json", m(l, v);
      let U = i && i.headers ? i.headers : {};
      return d.headers = { ...u, ...U, ...n.headers }, d.data = C(
        o,
        d,
        s
      ), {
        url: b(l),
        options: d
      };
    },
    /**
     * Create new invitation(s) to project
     * @param {Product} product
     * @param {string} projectId
     * @param {boolean} [uks]
     * @param {CreateInvitationsInput} [createInvitationsInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createInvitations: async (e, t, r, a, o = {}) => {
      p("createInvitations", "product", e), p("createInvitations", "projectId", t);
      const n = "/projects/{product}/{projectId}/invitations".replace("{product}", encodeURIComponent(String(e))).replace("{projectId}", encodeURIComponent(String(t))), c = new URL(n, I);
      let l;
      s && (l = s.baseOptions);
      const i = { method: "POST", ...l, ...o }, d = {}, u = {};
      r !== void 0 && (u.uks = r), d["Content-Type"] = "application/json", m(c, u);
      let v = l && l.headers ? l.headers : {};
      return i.headers = { ...d, ...v, ...o.headers }, i.data = C(a, i, s), {
        url: b(c),
        options: i
      };
    },
    /**
     * Create a shared project
     * @param {CreateProjectInput} [createProjectInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createProject: async (e, t = {}) => {
      const r = "/projects", a = new URL(r, I);
      let o;
      s && (o = s.baseOptions);
      const n = { method: "POST", ...o, ...t }, c = {}, l = {};
      c["Content-Type"] = "application/json", m(a, l);
      let i = o && o.headers ? o.headers : {};
      return n.headers = { ...c, ...i, ...t.headers }, n.data = C(e, n, s), {
        url: b(a),
        options: n
      };
    },
    /**
     * Get the details of an invitation
     * @param {string} invitationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInvitation: async (e, t = {}) => {
      p("getInvitation", "invitationId", e);
      const r = "/invitations/{invitationId}".replace(
        "{invitationId}",
        encodeURIComponent(String(e))
      ), a = new URL(r, I);
      let o;
      s && (o = s.baseOptions);
      const n = { method: "GET", ...o, ...t }, c = {};
      m(a, {});
      let i = o && o.headers ? o.headers : {};
      return n.headers = { ...c, ...i, ...t.headers }, {
        url: b(a),
        options: n
      };
    },
    /**
     * Get the details of an invitation
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInviteFromToken: async (e, t = {}) => {
      p("getInviteFromToken", "token", e);
      const r = "/invitation", a = new URL(r, I);
      let o;
      s && (o = s.baseOptions);
      const n = { method: "GET", ...o, ...t }, c = {}, l = {};
      e !== void 0 && (l.token = e), m(a, l);
      let i = o && o.headers ? o.headers : {};
      return n.headers = { ...c, ...i, ...t.headers }, {
        url: b(a),
        options: n
      };
    },
    /**
     * Get project details
     * @param {Product} product
     * @param {string} projectId
     * @param {boolean} [owner]
     * @param {boolean} [uks]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProject: async (e, t, r, a, o = {}) => {
      p("getProject", "product", e), p("getProject", "projectId", t);
      const n = "/projects/{product}/{projectId}".replace("{product}", encodeURIComponent(String(e))).replace("{projectId}", encodeURIComponent(String(t))), c = new URL(n, I);
      let l;
      s && (l = s.baseOptions);
      const i = { method: "GET", ...l, ...o }, d = {}, u = {};
      r !== void 0 && (u.owner = r), a !== void 0 && (u.uks = a), m(c, u);
      let v = l && l.headers ? l.headers : {};
      return i.headers = { ...d, ...v, ...o.headers }, {
        url: b(c),
        options: i
      };
    },
    /**
     * Get collaboration information for a user and project
     * @param {Product} product
     * @param {string} projectId
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProjectCollaborator: async (e, t, r, a = {}) => {
      p("getProjectCollaborator", "product", e), p("getProjectCollaborator", "projectId", t), p("getProjectCollaborator", "userId", r);
      const o = "/projects/{product}/{projectId}/collaborators/{userId}".replace("{product}", encodeURIComponent(String(e))).replace("{projectId}", encodeURIComponent(String(t))).replace("{userId}", encodeURIComponent(String(r))), n = new URL(o, I);
      let c;
      s && (c = s.baseOptions);
      const l = { method: "GET", ...c, ...a }, i = {};
      m(n, {});
      let u = c && c.headers ? c.headers : {};
      return l.headers = { ...i, ...u, ...a.headers }, {
        url: b(n),
        options: l
      };
    },
    /**
     * Get user details
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUser: async (e, t = {}) => {
      p("getUser", "userId", e);
      const r = "/users/{userId}".replace("{userId}", encodeURIComponent(String(e))), a = new URL(r, I);
      let o;
      s && (o = s.baseOptions);
      const n = { method: "GET", ...o, ...t }, c = {};
      m(a, {});
      let i = o && o.headers ? o.headers : {};
      return n.headers = { ...c, ...i, ...t.headers }, {
        url: b(a),
        options: n
      };
    },
    /**
     * List invitations for project
     * @param {Product} product
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listInvitationsForProject: async (e, t, r = {}) => {
      p("listInvitationsForProject", "product", e), p("listInvitationsForProject", "projectId", t);
      const a = "/projects/{product}/{projectId}/invitations".replace("{product}", encodeURIComponent(String(e))).replace("{projectId}", encodeURIComponent(String(t))), o = new URL(a, I);
      let n;
      s && (n = s.baseOptions);
      const c = { method: "GET", ...n, ...r }, l = {};
      m(o, {});
      let d = n && n.headers ? n.headers : {};
      return c.headers = { ...l, ...d, ...r.headers }, {
        url: b(o),
        options: c
      };
    },
    /**
     * List collaborators on a project (default: current)
     * @param {Product} product
     * @param {string} projectId
     * @param {boolean} [removed] Filter on whether the collaborators have been removed from the project.
     * @param {number} [take] How many collaborations to return
     * @param {number} [skip] How many records to skip
     * @param {ProjectRole} [role] Collaborator role
     * @param {boolean} [uks]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listProjectCollaborators: async (e, t, r, a, o, n, c, l = {}) => {
      p("listProjectCollaborators", "product", e), p("listProjectCollaborators", "projectId", t);
      const i = "/projects/{product}/{projectId}/collaborators".replace("{product}", encodeURIComponent(String(e))).replace("{projectId}", encodeURIComponent(String(t))), d = new URL(i, I);
      let u;
      s && (u = s.baseOptions);
      const v = { method: "GET", ...u, ...l }, U = {}, R = {};
      r !== void 0 && (R.removed = r), a !== void 0 && (R.take = a), o !== void 0 && (R.skip = o), n !== void 0 && (R.role = n), c !== void 0 && (R.uks = c), m(d, R);
      let g = u && u.headers ? u.headers : {};
      return v.headers = { ...U, ...g, ...l.headers }, {
        url: b(d),
        options: v
      };
    },
    /**
     * List projects a user is collaborating on
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listUserCollaborations: async (e = {}) => {
      const t = "/collaborations", r = new URL(t, I);
      let a;
      s && (a = s.baseOptions);
      const o = { method: "GET", ...a, ...e }, n = {};
      m(r, {});
      let l = a && a.headers ? a.headers : {};
      return o.headers = { ...n, ...l, ...e.headers }, {
        url: b(r),
        options: o
      };
    },
    /**
     * List pending invitations for a user
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listUserInvitations: async (e, t = {}) => {
      p("listUserInvitations", "userId", e);
      const r = "/users/{userId}/invitations".replace("{userId}", encodeURIComponent(String(e))), a = new URL(r, I);
      let o;
      s && (o = s.baseOptions);
      const n = { method: "GET", ...o, ...t }, c = {};
      m(a, {});
      let i = o && o.headers ? o.headers : {};
      return n.headers = { ...c, ...i, ...t.headers }, {
        url: b(a),
        options: n
      };
    },
    /**
     * Remove a collaborator from a project
     * @param {string} collaboratorId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    removeProjectCollaborator: async (e, t = {}) => {
      p("removeProjectCollaborator", "collaboratorId", e);
      const r = "/collaborators/{collaboratorId}".replace(
        "{collaboratorId}",
        encodeURIComponent(String(e))
      ), a = new URL(r, I);
      let o;
      s && (o = s.baseOptions);
      const n = { method: "DELETE", ...o, ...t }, c = {};
      m(a, {});
      let i = o && o.headers ? o.headers : {};
      return n.headers = { ...c, ...i, ...t.headers }, {
        url: b(a),
        options: n
      };
    },
    /**
     * Resend an invitation
     * @param {string} invitationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resendInvitation: async (e, t = {}) => {
      p("resendInvitation", "invitationId", e);
      const r = "/invitations/{invitationId}/resend".replace(
        "{invitationId}",
        encodeURIComponent(String(e))
      ), a = new URL(r, I);
      let o;
      s && (o = s.baseOptions);
      const n = { method: "POST", ...o, ...t }, c = {};
      m(a, {});
      let i = o && o.headers ? o.headers : {};
      return n.headers = { ...c, ...i, ...t.headers }, {
        url: b(a),
        options: n
      };
    },
    /**
     * Revoke an invitation. Returns the updatedAt invitation.
     * @param {string} invitationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    revokeInvitation: async (e, t = {}) => {
      p("revokeInvitation", "invitationId", e);
      const r = "/invitations/{invitationId}/revoke".replace(
        "{invitationId}",
        encodeURIComponent(String(e))
      ), a = new URL(r, I);
      let o;
      s && (o = s.baseOptions);
      const n = { method: "POST", ...o, ...t }, c = {};
      m(a, {});
      let i = o && o.headers ? o.headers : {};
      return n.headers = { ...c, ...i, ...t.headers }, {
        url: b(a),
        options: n
      };
    },
    /**
     * Modify a user\'s role on a project.
     * @param {string} collaboratorId
     * @param {UpdateProjectCollaboratorRoleInput} [updateProjectCollaboratorRoleInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateProjectCollaboratorRole: async (e, t, r = {}) => {
      p("updateProjectCollaboratorRole", "collaboratorId", e);
      const a = "/collaborators/{collaboratorId}/role".replace(
        "{collaboratorId}",
        encodeURIComponent(String(e))
      ), o = new URL(a, I);
      let n;
      s && (n = s.baseOptions);
      const c = { method: "PUT", ...n, ...r }, l = {}, i = {};
      l["Content-Type"] = "application/json", m(o, i);
      let d = n && n.headers ? n.headers : {};
      return c.headers = { ...l, ...d, ...r.headers }, c.data = C(
        t,
        c,
        s
      ), {
        url: b(o),
        options: c
      };
    }
  };
}, P = function(s) {
  const e = F(s);
  return {
    /**
     * Accept an invitation. Returns the updatedAt invitation.
     * @param {string} invitationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async acceptInvitation(t, r) {
      const a = await e.acceptInvitation(t, r);
      return O(a, h, j, s);
    },
    /**
     * Add a collaborator to a project
     * @param {Product} product
     * @param {string} projectId
     * @param {boolean} [removed] Filter on whether the collaborators have been removed from the project.
     * @param {boolean} [uks]
     * @param {CreateProjectCollaborationInput} [createProjectCollaborationInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addProjectCollaborator(t, r, a, o, n, c) {
      const l = await e.addProjectCollaborator(
        t,
        r,
        a,
        o,
        n,
        c
      );
      return O(l, h, j, s);
    },
    /**
     * Create new invitation(s) to project
     * @param {Product} product
     * @param {string} projectId
     * @param {boolean} [uks]
     * @param {CreateInvitationsInput} [createInvitationsInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createInvitations(t, r, a, o, n) {
      const c = await e.createInvitations(
        t,
        r,
        a,
        o,
        n
      );
      return O(c, h, j, s);
    },
    /**
     * Create a shared project
     * @param {CreateProjectInput} [createProjectInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createProject(t, r) {
      const a = await e.createProject(t, r);
      return O(a, h, j, s);
    },
    /**
     * Get the details of an invitation
     * @param {string} invitationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getInvitation(t, r) {
      const a = await e.getInvitation(t, r);
      return O(a, h, j, s);
    },
    /**
     * Get the details of an invitation
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getInviteFromToken(t, r) {
      const a = await e.getInviteFromToken(t, r);
      return O(a, h, j, s);
    },
    /**
     * Get project details
     * @param {Product} product
     * @param {string} projectId
     * @param {boolean} [owner]
     * @param {boolean} [uks]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getProject(t, r, a, o, n) {
      const c = await e.getProject(t, r, a, o, n);
      return O(c, h, j, s);
    },
    /**
     * Get collaboration information for a user and project
     * @param {Product} product
     * @param {string} projectId
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getProjectCollaborator(t, r, a, o) {
      const n = await e.getProjectCollaborator(
        t,
        r,
        a,
        o
      );
      return O(n, h, j, s);
    },
    /**
     * Get user details
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getUser(t, r) {
      const a = await e.getUser(t, r);
      return O(a, h, j, s);
    },
    /**
     * List invitations for project
     * @param {Product} product
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listInvitationsForProject(t, r, a) {
      const o = await e.listInvitationsForProject(t, r, a);
      return O(o, h, j, s);
    },
    /**
     * List collaborators on a project (default: current)
     * @param {Product} product
     * @param {string} projectId
     * @param {boolean} [removed] Filter on whether the collaborators have been removed from the project.
     * @param {number} [take] How many collaborations to return
     * @param {number} [skip] How many records to skip
     * @param {ProjectRole} [role] Collaborator role
     * @param {boolean} [uks]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listProjectCollaborators(t, r, a, o, n, c, l, i) {
      const d = await e.listProjectCollaborators(
        t,
        r,
        a,
        o,
        n,
        c,
        l,
        i
      );
      return O(d, h, j, s);
    },
    /**
     * List projects a user is collaborating on
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listUserCollaborations(t) {
      const r = await e.listUserCollaborations(t);
      return O(r, h, j, s);
    },
    /**
     * List pending invitations for a user
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listUserInvitations(t, r) {
      const a = await e.listUserInvitations(t, r);
      return O(a, h, j, s);
    },
    /**
     * Remove a collaborator from a project
     * @param {string} collaboratorId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async removeProjectCollaborator(t, r) {
      const a = await e.removeProjectCollaborator(t, r);
      return O(a, h, j, s);
    },
    /**
     * Resend an invitation
     * @param {string} invitationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async resendInvitation(t, r) {
      const a = await e.resendInvitation(t, r);
      return O(a, h, j, s);
    },
    /**
     * Revoke an invitation. Returns the updatedAt invitation.
     * @param {string} invitationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async revokeInvitation(t, r) {
      const a = await e.revokeInvitation(t, r);
      return O(a, h, j, s);
    },
    /**
     * Modify a user\'s role on a project.
     * @param {string} collaboratorId
     * @param {UpdateProjectCollaboratorRoleInput} [updateProjectCollaboratorRoleInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateProjectCollaboratorRole(t, r, a) {
      const o = await e.updateProjectCollaboratorRole(
        t,
        r,
        a
      );
      return O(o, h, j, s);
    }
  };
}, Y = function(s, e, t) {
  const r = P(s);
  return {
    /**
     * Accept an invitation. Returns the updatedAt invitation.
     * @param {string} invitationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    acceptInvitation(a, o) {
      return r.acceptInvitation(a, o).then((n) => n(t, e));
    },
    /**
     * Add a collaborator to a project
     * @param {Product} product
     * @param {string} projectId
     * @param {boolean} [removed] Filter on whether the collaborators have been removed from the project.
     * @param {boolean} [uks]
     * @param {CreateProjectCollaborationInput} [createProjectCollaborationInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addProjectCollaborator(a, o, n, c, l, i) {
      return r.addProjectCollaborator(a, o, n, c, l, i).then((d) => d(t, e));
    },
    /**
     * Create new invitation(s) to project
     * @param {Product} product
     * @param {string} projectId
     * @param {boolean} [uks]
     * @param {CreateInvitationsInput} [createInvitationsInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createInvitations(a, o, n, c, l) {
      return r.createInvitations(a, o, n, c, l).then((i) => i(t, e));
    },
    /**
     * Create a shared project
     * @param {CreateProjectInput} [createProjectInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createProject(a, o) {
      return r.createProject(a, o).then((n) => n(t, e));
    },
    /**
     * Get the details of an invitation
     * @param {string} invitationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInvitation(a, o) {
      return r.getInvitation(a, o).then((n) => n(t, e));
    },
    /**
     * Get the details of an invitation
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInviteFromToken(a, o) {
      return r.getInviteFromToken(a, o).then((n) => n(t, e));
    },
    /**
     * Get project details
     * @param {Product} product
     * @param {string} projectId
     * @param {boolean} [owner]
     * @param {boolean} [uks]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProject(a, o, n, c, l) {
      return r.getProject(a, o, n, c, l).then((i) => i(t, e));
    },
    /**
     * Get collaboration information for a user and project
     * @param {Product} product
     * @param {string} projectId
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProjectCollaborator(a, o, n, c) {
      return r.getProjectCollaborator(a, o, n, c).then((l) => l(t, e));
    },
    /**
     * Get user details
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUser(a, o) {
      return r.getUser(a, o).then((n) => n(t, e));
    },
    /**
     * List invitations for project
     * @param {Product} product
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listInvitationsForProject(a, o, n) {
      return r.listInvitationsForProject(a, o, n).then((c) => c(t, e));
    },
    /**
     * List collaborators on a project (default: current)
     * @param {Product} product
     * @param {string} projectId
     * @param {boolean} [removed] Filter on whether the collaborators have been removed from the project.
     * @param {number} [take] How many collaborations to return
     * @param {number} [skip] How many records to skip
     * @param {ProjectRole} [role] Collaborator role
     * @param {boolean} [uks]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listProjectCollaborators(a, o, n, c, l, i, d, u) {
      return r.listProjectCollaborators(a, o, n, c, l, i, d, u).then((v) => v(t, e));
    },
    /**
     * List projects a user is collaborating on
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listUserCollaborations(a) {
      return r.listUserCollaborations(a).then((o) => o(t, e));
    },
    /**
     * List pending invitations for a user
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listUserInvitations(a, o) {
      return r.listUserInvitations(a, o).then((n) => n(t, e));
    },
    /**
     * Remove a collaborator from a project
     * @param {string} collaboratorId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    removeProjectCollaborator(a, o) {
      return r.removeProjectCollaborator(a, o).then((n) => n(t, e));
    },
    /**
     * Resend an invitation
     * @param {string} invitationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resendInvitation(a, o) {
      return r.resendInvitation(a, o).then((n) => n(t, e));
    },
    /**
     * Revoke an invitation. Returns the updatedAt invitation.
     * @param {string} invitationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    revokeInvitation(a, o) {
      return r.revokeInvitation(a, o).then((n) => n(t, e));
    },
    /**
     * Modify a user\'s role on a project.
     * @param {string} collaboratorId
     * @param {UpdateProjectCollaboratorRoleInput} [updateProjectCollaboratorRoleInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateProjectCollaboratorRole(a, o, n) {
      return r.updateProjectCollaboratorRole(a, o, n).then((c) => c(t, e));
    }
  };
};
class z extends w {
  /**
   * Accept an invitation. Returns the updatedAt invitation.
   * @param {string} invitationId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  acceptInvitation(e, t) {
    return P(this.configuration).acceptInvitation(e, t).then((r) => r(this.axios, this.basePath));
  }
  /**
   * Add a collaborator to a project
   * @param {Product} product
   * @param {string} projectId
   * @param {boolean} [removed] Filter on whether the collaborators have been removed from the project.
   * @param {boolean} [uks]
   * @param {CreateProjectCollaborationInput} [createProjectCollaborationInput]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  addProjectCollaborator(e, t, r, a, o, n) {
    return P(this.configuration).addProjectCollaborator(e, t, r, a, o, n).then((c) => c(this.axios, this.basePath));
  }
  /**
   * Create new invitation(s) to project
   * @param {Product} product
   * @param {string} projectId
   * @param {boolean} [uks]
   * @param {CreateInvitationsInput} [createInvitationsInput]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  createInvitations(e, t, r, a, o) {
    return P(this.configuration).createInvitations(e, t, r, a, o).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Create a shared project
   * @param {CreateProjectInput} [createProjectInput]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  createProject(e, t) {
    return P(this.configuration).createProject(e, t).then((r) => r(this.axios, this.basePath));
  }
  /**
   * Get the details of an invitation
   * @param {string} invitationId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  getInvitation(e, t) {
    return P(this.configuration).getInvitation(e, t).then((r) => r(this.axios, this.basePath));
  }
  /**
   * Get the details of an invitation
   * @param {string} token
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  getInviteFromToken(e, t) {
    return P(this.configuration).getInviteFromToken(e, t).then((r) => r(this.axios, this.basePath));
  }
  /**
   * Get project details
   * @param {Product} product
   * @param {string} projectId
   * @param {boolean} [owner]
   * @param {boolean} [uks]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  getProject(e, t, r, a, o) {
    return P(this.configuration).getProject(e, t, r, a, o).then((n) => n(this.axios, this.basePath));
  }
  /**
   * Get collaboration information for a user and project
   * @param {Product} product
   * @param {string} projectId
   * @param {string} userId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  getProjectCollaborator(e, t, r, a) {
    return P(this.configuration).getProjectCollaborator(e, t, r, a).then((o) => o(this.axios, this.basePath));
  }
  /**
   * Get user details
   * @param {string} userId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  getUser(e, t) {
    return P(this.configuration).getUser(e, t).then((r) => r(this.axios, this.basePath));
  }
  /**
   * List invitations for project
   * @param {Product} product
   * @param {string} projectId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  listInvitationsForProject(e, t, r) {
    return P(this.configuration).listInvitationsForProject(e, t, r).then((a) => a(this.axios, this.basePath));
  }
  /**
   * List collaborators on a project (default: current)
   * @param {Product} product
   * @param {string} projectId
   * @param {boolean} [removed] Filter on whether the collaborators have been removed from the project.
   * @param {number} [take] How many collaborations to return
   * @param {number} [skip] How many records to skip
   * @param {ProjectRole} [role] Collaborator role
   * @param {boolean} [uks]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  listProjectCollaborators(e, t, r, a, o, n, c, l) {
    return P(this.configuration).listProjectCollaborators(e, t, r, a, o, n, c, l).then((i) => i(this.axios, this.basePath));
  }
  /**
   * List projects a user is collaborating on
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  listUserCollaborations(e) {
    return P(this.configuration).listUserCollaborations(e).then((t) => t(this.axios, this.basePath));
  }
  /**
   * List pending invitations for a user
   * @param {string} userId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  listUserInvitations(e, t) {
    return P(this.configuration).listUserInvitations(e, t).then((r) => r(this.axios, this.basePath));
  }
  /**
   * Remove a collaborator from a project
   * @param {string} collaboratorId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  removeProjectCollaborator(e, t) {
    return P(this.configuration).removeProjectCollaborator(e, t).then((r) => r(this.axios, this.basePath));
  }
  /**
   * Resend an invitation
   * @param {string} invitationId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  resendInvitation(e, t) {
    return P(this.configuration).resendInvitation(e, t).then((r) => r(this.axios, this.basePath));
  }
  /**
   * Revoke an invitation. Returns the updatedAt invitation.
   * @param {string} invitationId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  revokeInvitation(e, t) {
    return P(this.configuration).revokeInvitation(e, t).then((r) => r(this.axios, this.basePath));
  }
  /**
   * Modify a user\'s role on a project.
   * @param {string} collaboratorId
   * @param {UpdateProjectCollaboratorRoleInput} [updateProjectCollaboratorRoleInput]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  updateProjectCollaboratorRole(e, t, r) {
    return P(this.configuration).updateProjectCollaboratorRole(e, t, r).then((a) => a(this.axios, this.basePath));
  }
}
var N = /* @__PURE__ */ ((s) => (s["projects:users:invite"] = "projects:users:invite", s["projects:users:read"] = "projects:users:read", s["projects:users:delete"] = "projects:users:delete", s["projects:roles:update"] = "projects:roles:update", s["projects:invitations:delete"] = "projects:invitations:delete", s["projects:invitations:update"] = "projects:invitations:update", s["projects:stats:read"] = "projects:stats:read", s["projects:settings:read"] = "projects:settings:read", s["projects:settings:update"] = "projects:settings:update", s["projects:security:read"] = "projects:security:read", s["projects:security:update"] = "projects:security:update", s["ipfs:pins:delete"] = "ipfs:pins:delete", s["ipfs:pins:read"] = "ipfs:pins:read", s["projects:create"] = "projects:create", s["projects:delete"] = "projects:delete", s["account:settings:read"] = "account:settings:read", s["account:delete"] = "account:delete", s))(N || {});
const T = {
  [y.OWNER]: {
    "projects:users:invite": !0,
    "projects:users:read": !0,
    "projects:users:delete": !0,
    "projects:roles:update": !0,
    "projects:invitations:delete": !0,
    "projects:invitations:update": !0,
    "projects:stats:read": !0,
    "projects:settings:read": !0,
    "projects:settings:update": !0,
    "projects:security:read": !0,
    "projects:security:update": !0,
    "ipfs:pins:delete": !0,
    "ipfs:pins:read": !0,
    "projects:create": !0,
    "projects:delete": !0,
    "account:settings:read": !0,
    "account:delete": !0
  },
  [y.ADMIN]: {
    "projects:users:invite": !0,
    "projects:users:read": !0,
    "projects:users:delete": !0,
    "projects:roles:update": !0,
    "projects:invitations:delete": !0,
    "projects:invitations:update": !0,
    "projects:stats:read": !0,
    "projects:settings:read": !0,
    "projects:settings:update": !0,
    "projects:security:read": !0,
    "projects:security:update": !0,
    "ipfs:pins:delete": !0,
    "ipfs:pins:read": !0
  },
  [y.CONTRIBUTOR]: {
    "projects:stats:read": !0,
    "projects:settings:read": !0,
    "projects:security:read": !0,
    "ipfs:pins:delete": !0,
    "ipfs:pins:read": !0
  }
}, Z = Object.keys(T.owner), ee = Object.keys(T.admin), te = Object.keys(T.contributor);
class re {
  constructor(e = {}) {
    /**
     * parameter for apiKey security
     * @param name security name
     * @memberof Configuration
     */
    V(this, "apiKey");
    /**
     * parameter for basic security
     *
     * @type {string}
     * @memberof Configuration
     */
    V(this, "username");
    /**
     * parameter for basic security
     *
     * @type {string}
     * @memberof Configuration
     */
    V(this, "password");
    /**
     * parameter for oauth2 security
     * @param name security name
     * @param scopes oauth2 scope
     * @memberof Configuration
     */
    V(this, "accessToken");
    /**
     * override base path
     *
     * @type {string}
     * @memberof Configuration
     */
    V(this, "basePath");
    /**
     * base options for axios calls
     *
     * @type {any}
     * @memberof Configuration
     */
    V(this, "baseOptions");
    /**
     * The FormData constructor that will be used to create multipart form data
     * requests. You can inject this here so that execution environments that
     * do not support the FormData class can still run the generated client.
     *
     * @type {new () => FormData}
     */
    V(this, "formDataCtor");
    this.apiKey = e.apiKey, this.username = e.username, this.password = e.password, this.accessToken = e.accessToken, this.basePath = e.basePath, this.baseOptions = e.baseOptions, this.formDataCtor = e.formDataCtor;
  }
  /**
   * Check if the given MIME is a JSON MIME.
   * JSON MIME examples:
   *   application/json
   *   application/json; charset=UTF8
   *   APPLICATION/JSON
   *   application/vnd.company+json
   * @param mime - MIME (Multipurpose Internet Mail Extensions)
   * @return True if the given MIME is JSON, false otherwise.
   */
  isJsonMime(e) {
    const t = new RegExp("^(application/json|[^;/ 	]+/[^;/ 	]+[+]json)[ 	]*(;.*)?$", "i");
    return e !== null && (t.test(e) || e.toLowerCase() === "application/json-patch+json");
  }
}
export {
  ee as ADMIN_ACTIONS,
  N as Actions,
  x as AdminProjectEntityTypeEnum,
  Q as BaseProject1EntityTypeEnum,
  te as CONTRIBUTOR_ACTIONS,
  re as Configuration,
  B as CreateInvitationErrorStatusEnum,
  z as DefaultApi,
  F as DefaultApiAxiosParamCreator,
  Y as DefaultApiFactory,
  P as DefaultApiFp,
  $ as ETHProductAddonsEnum,
  L as ETHTier,
  q as ErrorCode,
  k as InfuraPlusStatusTermsEnum,
  G as InvitationResponseAllOfProjectEntityTypeEnum,
  M as InvitationResponseStatusEnum,
  H as InvitationStatusEnum,
  J as IpfsProjectEntityTypeEnum,
  Z as OWNER_ACTIONS,
  T as Permissions,
  K as Product,
  W as ProjectCollaboratorRole,
  y as ProjectRole,
  X as User1RelationshipEnum
};
